<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" :format="dateFormat" :placeholder="datePickerPlaceholder" style="width:100%"/>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input label="Sort By" >
                                <select class="form-control" size="large" v-model="inputSortBy">
                                    <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-2 mt-3 pt-3">
                            <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" v-model="inputGroupBy">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input label="Filtered By" >
                                <select class="form-control" v-model="inputFilterBy">
                                    <option v-for="option in filterOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <download-excel
                                worksheet="Sales Reports"
                                :name="excelFileName"
                                type="xls"
                                :fetch="excelData"
                                :fields="excelHeaders">
                                <button class="btn btn-sm btn-success float-right ml-2"
                                        style="border-radius: 24px; border:0px; width: 20%;">
                                    Generate Report in Excel
                                </button>
                            </download-excel>

                            <button class="btn btn-sm btn-default float-right"
                                    style="border-radius: 24px; border:0px; width: 20%;"
                                    @click.prevent="generateReport">
                                Generate Report in PDF
                            </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
          return {
            spinning: false,
            inputSortBy: 'trans_id',
            inputGroupBy: '',
            inputFilterBy: 2,
            inputSite: [],
            inputDate: [moment().startOf('day'), moment().endOf('day')],
            sortOptions: [
                {key: 'trans_id', value: 'Trans #'},
                {key: 'document_date', value: 'Date Time'}
            ],
            groupOptions: [
                {key: '', value: '[Flat List]'},
                {key: 'user_id', value: 'Cashier'},
                {key: 'customer_id', value: 'Customer'}
            ],
            filterOptions: [
                {key: 0, value: '[All Members]'},
                {key: 1, value: '[Non-Members]'},
                {key: 2, value: '[All Customers]'}
            ],
            siteOptions: [],
            dateFormat: 'MM/DD/YYYY hh:mm A',
            datePickerPlaceholder: ['Start', 'End'],
            birSalesReports: [],
            site_type: 'ho',

            showSortInfo: 'asc',
            imagepath: '',
            excelFileName: "sales_reports.xls",
            excelHeaders: {
              "Date": "date",
              "Time": "time",
              "Customer Name": "customerName",
              "Guest Count": "guestCount",
              "ID No": "idNo",
              "Customer TIN": "customerTin",
              "SI Number": "siOrNo",
              "Sales (inclusive of VAT)": "sales",
              "VAT Amount": "vatAmount",
              "VAT Exempt (Sales)": "vatExempt",
              "5% Discount": "sp5Discount",
              "20%  Discount": "sp20Discount",
              "Net Sales": "netSales"
            }
          }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(component_x.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                component_x.site_type = site.site_type
            }

            let logoSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=account_logo', null)
            if (logoSettings.length > 0) {
                let logo_img = logoSettings[0]["value"]
                this.imagepath = this.publicUrl + 'account_logos/' + logo_img
            }

            this.initializeExportExcel();
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'publicUrl']),
        },
        watch: {
          currentProfile() {
            this.initializeExportExcel();
          }
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            convertToCurrency(num){
              return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                if(type == 'error'){
                    this.$notification[type]({
                        message: 'Export Error',
                        description: msg
                    });
                }else if(type == 'warning'){
                    this.$notification[type]({
                        message: 'No Data Found',
                        description: msg
                    });
                }
            },
            initializeExportExcel() {
              if(this.currentProfile == 'senior_citizen_sales_reports'){
                this.excelFileName = `Senior_Citizen_Sales_Report_${moment().format('YYYYMMDDHHmmss')}.xls`;
                this.excelHeaders = {
                  "Terminal Name": "terminalName",
                  "Cashier Name": "cashierName",
                  "Date": "date",
                  "Time": "time",
                  "Name of Senior Citizen (SC)": "customerName",
                  "Guest Count": "guestCount",
                  "OSCA No.": "idNo",
                  "SC TIN.": "customerTin",
                  "SI Number": "siOrNo",
                  "Sales (inclusive of VAT)": "sales",
                  "VAT Amount": "vatAmount",
                  "VAT Exempt (Sales)": "vatExempt",
                  "5% Discount": "sp5Discount",
                  "20% Discount": "sp20Discount",
                  "Net Sales": "netSales"
                }
              }else {
                this.excelFileName = `PWD_Sales_Report_${moment().format('YYYYMMDDHHmmss')}.xls`;
                this.excelHeaders = {
                  "Terminal Name": "terminalName",
                  "Cashier Name": "cashierName",
                  "Date": "date",
                  "Time": "time",
                  "Name of Person with Disability (PWD)": "customerName",
                  "Guest Count": "guestCount",
                  "PWD No.": "idNo",
                  "PWD TIN.": "customerTin",
                  "SI / OR Number": "siOrNo",
                  "Sales (inclusive of VAT)": "sales",
                  "VAT Amount": "vatAmount",
                  "VAT Exempt (Sales)": "vatExempt",
                  "5% Discount": "sp5Discount",
                  "20% Discount": "sp20Discount",
                  "Net Sales": "netSales"
                }
              }
            },
            excelData: async function() {
              this.spinning= true;
              let jsonData = [];
              let request = {};
              let total_sales = 0
              let total_vatAmount = 0
              let total_vatExempt = 0
              let total_discount = 0
              let total_other_discount = 0
              let total_sp5_discount = 0
              let total_sp20_discount = 0
              let total_netSales = 0

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    this.spinning= false;
                    return
                }

              if(this.currentProfile == 'senior_citizen_sales_reports'){
                request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/senior_citizen_book?site_id=' + this.inputSite +
                    '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') +
                    '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&group=' + this.inputGroupBy + '&filter=' + this.inputFilterBy, null, "BXI-File")
              }else {
                request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/pwd_book?site_id=' + this.inputSite +
                    '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') +
                    '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&group=' + this.inputGroupBy + '&filter=' + this.inputFilterBy, null, "BXI-File")
              }

              if (!request[0]) {
                this.openNotificationWithIcon('warning', 'No data found, try increasing the scope by adjusting the filters.');
                this.spinning= false;
                return;
            }

            var siteSpecific = request;

            if(siteSpecific.length > 0){
                for(var x=0; x < siteSpecific.length; x++){
                    this.birSalesReports = siteSpecific[x].report_details
                    let reportDetails = this.birSalesReports

                    reportDetails.map(detail => {
                        total_sales += Number(detail.amount_wvat)
                        total_vatAmount += Number(detail.vat_amount)
                        total_vatExempt += Number(detail.vat_exempt)
                        total_discount += Number(detail.discount_amount)
                        total_other_discount += Number(detail.other_discount_amount)
                        total_sp5_discount += Number(detail.sp5_discount_amount)
                        total_sp20_discount += Number(detail.sp20_discount_amount)
                        total_netSales += Number(detail.net_sales)
                        jsonData.push({
                            terminalName: detail.terminal_name,
                            cashierName: detail.cashier_name,
                            date: moment(detail.document_date).format('MM/DD/YYYY'),
                            time: moment(detail.document_date).format('HH:mm:ss'),
                            idNo: detail.card_number,
                            customerName: detail.customer_name,
                            guestCount: detail.guest_count,
                            siOrNo: detail.invoice_no,
                            sales: this.convertToCurrency(Number(detail.amount_wvat)),
                            vatAmount: this.convertToCurrency(Number(detail.vat_amount)),
                            vatExempt: this.convertToCurrency(Number(detail.vat_exempt)),
                            discount: this.convertToCurrency(Number(detail.discount_amount)),
                            otherDiscountAmount: this.convertToCurrency(Number(detail.other_discount_amount)),
                            sp5Discount: this.convertToCurrency(Number(detail.sp5_discount_amount)),
                            sp20Discount: this.convertToCurrency(Number(detail.sp20_discount_amount)),
                            netSales: this.convertToCurrency(Number(detail.net_sales))
                        })
                    }) 
                }
                this.spinning= false;

                jsonData.push({
                    terminalName: '',
                    cashierName: '',
                    date: '',
                    time: '',
                    idNo: '',
                    customerName: '',
                    guestCount: '',
                    siOrNo: 'Grand Total:',
                    sales: this.convertToCurrency(Number(total_sales)),
                    vatAmount: this.convertToCurrency(Number(total_vatAmount)),
                    vatExempt: this.convertToCurrency(Number(total_vatExempt)),
                    discount: this.convertToCurrency(Number(total_discount)),
                    otherDiscountAmount: this.convertToCurrency(Number(total_other_discount)),
                    sp5Discount: this.convertToCurrency(Number(total_sp5_discount)),
                    sp20Discount: this.convertToCurrency(Number(total_sp20_discount)),
                    netSales: this.convertToCurrency(Number(total_netSales))
                })
            }

            return jsonData
            },
            generateReport: async function () {
                this.spinning= true;
                var get_request = {}

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    this.spinning= false;
                    return
                }

                let header_card = "OSCA #"
                let cust_name = "Name of Senior Citizen (SC)"
                let header_table = 'Senior Citizen Sales Book/Report'
                let header_tin = 'SC TIN'
                if(this.currentProfile == 'senior_citizen_sales_reports'){
                    get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/senior_citizen_book?site_id=' + this.inputSite +
                        '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') +
                        '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&group=' + this.inputGroupBy + '&filter=' + this.inputFilterBy, null, "BXI-File")
                }else {
                    header_card = "PWD #"
                    cust_name = "Name of Person with Disability (PWD) "
                    header_table = 'Persons with Disability Sales Book/Report'
                    header_tin = 'PWD TIN'
                    get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/pwd_book?site_id=' + this.inputSite +
                        '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') +
                        '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&group=' + this.inputGroupBy + '&filter=' + this.inputFilterBy, null, "BXI-File")
                }
                if(get_request.error) {
                    this.openNotificationWithIcon('error', get_request.error);
                    return
                }
                var siteSpecific = get_request;

                if(siteSpecific.length > 0){
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    for(var x=0; x < siteSpecific.length; x++){
                        let design_x = 15
                        let design_y = 15

                        let headerColStyles = {
                            0: {cellWidth: 25},
                            1: {cellWidth: 25},
                            2: {cellWidth: 45},
                            3: {cellWidth: 15},
                            4: {cellWidth: 20},
                            5: {cellWidth: 30},
                            6: {cellWidth: 20},
                            7: {cellWidth: 25},
                            8: {cellWidth: 25},
                            9: {cellWidth: 25},
                            10: {cellWidth: 25},
                            11: {cellWidth: 25},
                            12: {cellWidth: 25},
                        }

                        let detailColStyles = {
                            0: {cellWidth: 25},
                            1: {cellWidth: 25},
                            2: {cellWidth: 45},
                            3: {cellWidth: 15},
                            4: {cellWidth: 20},
                            5: {cellWidth: 30},
                            6: {cellWidth: 20},
                            7: {cellWidth: 25},
                            8: {cellWidth: 25},
                            9: {cellWidth: 25},
                            10: {cellWidth: 25},
                            11: {cellWidth: 25},
                            12: {cellWidth: 25},
                        }

                        //add new page
                        if(x > 0){   
                            doc.addPage();
                        }

                        let reportLogo = document.getElementById('reportLogo');
                        doc.addImage(reportLogo, "PNG", 15, 5, 20, 25);

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(siteSpecific[x].report_details[0].company_name, doc.internal.pageSize.width / 2, design_y, null, null, 'center');

                        design_y = design_y + 5
                        doc.text(siteSpecific[x].report_details[0].company_address, doc.internal.pageSize.width / 2, design_y, null, null, 'center');

                        design_y = design_y + 5
                        doc.text(siteSpecific[x].report_details[0].company_tin, doc.internal.pageSize.width / 2, design_y, null, null, 'center');

                        doc.setFontSize(10);
                        doc.setFontType("normal");    

                        this.birSalesReports = siteSpecific[x].report_details

                        let main_grouper = ''
                        let grouper = ''
                        let grouper_text = ''
                        if(this.birSalesReports.length > 0){
                            let reportData = []

                            let g_amount_wvat = 0
                            let g_vat_amount = 0
                            let g_vat_exempt = 0
                            let g_other_discount_amount = 0
                            let g_sp5_discount_amount = 0
                            let g_sp20_discount_amount = 0
                            let g_net_sales = 0

                            let total_amount_wvat = 0
                            let total_vat_amount = 0
                            let total_vat_exempt = 0
                            let total_discount_amount = 0
                            let total_other_discount_amount = 0
                            let total_sp5_discount_amount = 0
                            let total_sp20_discount_amount = 0
                            let total_net_sales = 0

                            for(var i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let detail = []

                                if(this.inputGroupBy == 'user_id'){
                                    if(grouper == ''){
                                        let detail_header = ["Cashier: ", {content: reportLine.cashier_name, colSpan: 9, styles: {halign: 'left'}}]
                                        reportData.push(detail_header)
                                    } else {
                                        if(grouper != reportLine.user_id){
                                            let detail_header = ["Cashier: ", {content: reportLine.cashier_name , colSpan: 9, styles: {halign: 'left'}}]
                                            reportData.push(detail_header)
                                        }
                                    }
                                    grouper = reportLine.user_id
                                }else if(this.inputGroupBy == 'customer_id'){
                                    if(grouper == '' && grouper_text == ''){
                                        let detail_header = ["Customer :", {content: reportLine.customer_name , colSpan: 9, styles: {halign: 'left'}}]
                                        reportData.push(detail_header)
                                    } else {
                                    if(grouper != reportLine.customer_id){
                                            let detail_header = ["Customer :", {content: reportLine.customer_name , colSpan: 9, styles: {halign: 'left'}}]
                                            reportData.push(detail_header)
                                        } else {
                                            if(reportLine.customer_id == 0){
                                                let current_grouper = reportLine.customer_name
                                                let prev_grouper = this.birSalesReports[i-1].customer_name
                                                if(current_grouper != prev_grouper){
                                                    let detail_header = ["Customer :", {content: reportLine.customer_name , colSpan: 9, styles: {halign: 'left'}}]
                                                    reportData.push(detail_header)
                                                }
                                            }
                                        }
                                    }

                                    grouper = reportLine.customer_id
                                    grouper_text = reportLine.customer_name
                                }

                                //set table rows
                                detail = [
                                    {content: moment(reportLine.document_date).format('MM/DD/YYYY'), styles: {halign: 'center'}},
                                    {content: moment(reportLine.document_date).format('HH:mm:ss'), styles: {halign: 'center'}},
                                    {content: reportLine.customer_name, styles: {halign: 'left'}},
                                    {content: reportLine.guest_count, styles: {halign: 'center'}},
                                    {content: reportLine.card_number, styles: {halign: 'left'}},
                                    {content: reportLine.customer_tin, styles: {halign: 'left'}},
                                    {content: reportLine.invoice_no, styles: {halign: 'center'}},
                                    this.convertToCurrency(Number(reportLine.amount_wvat)),
                                    this.convertToCurrency(Number(reportLine.vat_amount)),
                                    this.convertToCurrency(Number(reportLine.vat_exempt)),
                                    this.convertToCurrency(Number(reportLine.sp5_discount_amount)),
                                    this.convertToCurrency(Number(reportLine.sp20_discount_amount)),
                                    this.convertToCurrency(Number(reportLine.net_sales))
                                ]
                                reportData.push(detail)

                                g_amount_wvat += Number(reportLine.amount_wvat)
                                g_vat_amount += Number(reportLine.vat_amount)
                                g_vat_exempt += Number(reportLine.vat_exempt)
                                g_sp5_discount_amount += Number(reportLine.sp5_discount_amount)
                                g_sp20_discount_amount += Number(reportLine.sp20_discount_amount)
                                g_net_sales += Number(reportLine.net_sales)

                                total_amount_wvat += Number(reportLine.amount_wvat)
                                total_vat_amount += Number(reportLine.vat_amount)
                                total_vat_exempt += Number(reportLine.vat_exempt)
                                total_sp5_discount_amount += Number(reportLine.sp5_discount_amount)
                                total_sp20_discount_amount += Number(reportLine.sp20_discount_amount)
                                total_net_sales += Number(reportLine.net_sales)

                                if(main_grouper == ''){
                                    design_y = design_y + 10
                                    doc.text(design_x, design_y, "Software")
                                    doc.text(design_x+50, design_y, "Barter FPOS 5.1")

                                    design_y = design_y + 5
                                    doc.text(design_x, design_y, "Serial Number")
                                    doc.text(design_x+50, design_y, reportLine.serial_number)

                                    design_y = design_y + 5
                                    doc.text(design_x, design_y, "Machine Number")
                                    doc.text(design_x+50, design_y, reportLine.machine_number)

                                    design_y = design_y + 5
                                    doc.text(design_x, design_y, "POS Terminal Number")
                                    doc.text(design_x+50, design_y, reportLine.terminal_name)

                                    design_y = design_y + 5
                                    doc.text(design_x, design_y, "Business Date Covered")
                                    // doc.text(design_x+50, design_y, `${moment().format('MM/DD/YYYY hh:mm a')}`)
                                    doc.text(design_x+50, design_y, this.inputDate[0].format('MM/DD/YYYY') + ' to ' + this.inputDate[1].format('MM/DD/YYYY'))


                                    // design_y = design_y + 5
                                    // doc.text(design_x, design_y, "User")
                                    // doc.text(design_x+50, design_y, secureStorage.getItem("email"))

                                    design_y = design_y + 5
                                    let headers = [
                                        [
                                            {content: header_table, colSpan: 13, styles: {halign: 'center'}}
                                        ],
                                        [
                                            {content: 'Date', rowSpan: 2, styles: {halign: 'center'}},
                                            {content: 'Time', rowSpan: 2, styles: {halign: 'center'}},
                                            {content: cust_name, rowSpan: 2, styles: {halign: 'center'}},
                                            {content: 'Guest Count', rowSpan: 2, styles: {halign: 'center'}},
                                            {content: header_card, rowSpan: 2, styles: {halign: 'center'}},
                                            {content: header_tin, rowSpan: 2, styles: {halign: 'center'}},
                                            {content: 'SI #', rowSpan: 2, styles: {halign: 'center'}},
                                            {content: 'Sales\n(inclusive of VAT)', rowSpan: 2, styles: {halign: 'center'}},
                                            {content: 'VAT Amount', rowSpan: 2, styles: {halign: 'center'}},
                                            {content: 'VAT Exempt\nSales', rowSpan: 2, styles: {halign: 'center'}},
                                            {content: 'Discount', colSpan: 2, styles: {halign: 'center'}},
                                            {content: 'Net Sales', rowSpan: 2, styles: {halign: 'center'}}
                                        ],
                                        [
                                            { content: "5%", styles: { halign: "center" } },
                                            { content: "20%", styles: { halign: "center" } }
                                        ]
                                    ]
                                    design_y = design_y + 3
                                    doc.autoTable({
                                        startY: design_y,
                                        head: headers,
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: headerColStyles
                                    });
                                } else {
                                    if(main_grouper != reportLine.terminal_id){

                                        //if new terminal display prev terminal details
                                        design_y = design_y + 15

                                        if(this.inputGroupBy != ''){
                                            let total = [
                                                '',
                                                '',
                                                '',
                                                '','', '',
                                                'Total :',
                                                this.convertToCurrency(total_amount_wvat),
                                                this.convertToCurrency(total_vat_amount),
                                                this.convertToCurrency(total_vat_exempt),
                                                this.convertToCurrency(total_sp5_discount_amount),
                                                this.convertToCurrency(total_sp20_discount_amount),
                                                this.convertToCurrency(total_net_sales)
                                            ]
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, total))

                                            total_amount_wvat = 0
                                            total_vat_amount = 0
                                            total_vat_exempt = 0
                                            total_sp5_discount_amount = 0
                                            total_sp20_discount_amount = 0
                                            total_net_sales = 0
                                        }

                                        let grand = [
                                            '',
                                            '',
                                            '',
                                            '','', '',
                                            'Grand Total :',
                                            this.convertToCurrency(g_amount_wvat),
                                            this.convertToCurrency(g_vat_amount),
                                            this.convertToCurrency(g_vat_exempt),
                                            this.convertToCurrency(g_sp5_discount_amount),
                                            this.convertToCurrency(g_sp20_discount_amount),
                                            this.convertToCurrency(g_net_sales)
                                        ]
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, grand))

                                        g_amount_wvat = 0
                                        g_vat_amount = 0
                                        g_vat_exempt = 0
                                        g_sp5_discount_amount = 0
                                        g_sp20_discount_amount = 0
                                        g_net_sales = 0

                                        grouper = ''
                                        grouper_text = ''
                                          design_y = design_y + 5
                                        doc.autoTable({
                                            startY: design_y,
                                            body: reportData,
                                            theme: 'plain',
                                            tableWidth: 'wrap',
                                            styles: {
                                                cellPadding: 1.0, fontSize: 9,
                                                halign: 'right'
                                            },
                                            columnStyles: detailColStyles,
                                            didParseCell: function(data) {
                                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                    data.cell.styles.fillColor = [0, 0, 0]
                                                    data.cell.styles.fontSize = 1
                                                    data.cell.styles.cellPadding = 0
                                                } else if (data.row.section == 'body' && (data.row.raw[3] == 'Grand Total :' || data.row.raw[3] == 'Total :')){
                                                    data.cell.styles.fontStyle = 'bold'
                                                }
                                            }
                                        });
                                        reportData = []

                                        //add new page
                                        doc.addPage();

                                        design_x = 15
                                        design_y = 15

                                        doc.text(design_x, design_y, "Software")
                                        doc.text(design_x+50, design_y, "Barter FPOS 5.1")

                                        design_y = design_y + 5
                                        doc.text(design_x, design_y, "Serial Number")
                                        doc.text(design_x+50, design_y, reportLine.serial_number)

                                        design_y = design_y + 5
                                        doc.text(design_x, design_y, "Machine Number")
                                        doc.text(design_x+50, design_y, reportLine.machine_number)

                                        design_y = design_y + 5
                                        doc.text(design_x, design_y, "POS Terminal Number")
                                        doc.text(design_x+50, design_y, reportLine.terminal_name)

                                        design_y = design_y + 5
                                        doc.text(design_x, design_y, "Date Generated")
                                        // doc.text(design_x+50, design_y, `${moment().format('MM/DD/YYYY hh:mm a')}`)
                                        doc.text(design_x+50, design_y, this.inputDate[0].format('MM/DD/YYYY') + ' to ' + this.inputDate[1].format('MM/DD/YYYY'))


                                        // design_y = design_y + 5
                                        // doc.text(design_x, design_y, "User")
                                        // doc.text(design_x+50, design_y, secureStorage.getItem("email"))
                                        design_y = design_y + 5
                                        let headers = [
                                            [
                                                {content: header_table, colSpan: 13, styles: {halign: 'center'}}
                                            ],
                                            [
                                                {content: 'Date', rowSpan: 2, styles: {halign: 'center'}},
                                                {content: 'Time', rowSpan: 2, styles: {halign: 'center'}},
                                                {content: cust_name, rowSpan: 2, styles: {halign: 'center'}},
                                                {content: 'Guest Count', rowSpan: 2, styles: {halign: 'center'}},
                                                {content: header_card, rowSpan: 2, styles: {halign: 'center'}},
                                                {content: header_tin, rowSpan: 2, styles: {halign: 'center'}},
                                                {content: 'SI #', rowSpan: 2, styles: {halign: 'center'}},
                                                {content: 'Sales\n(inclusive of VAT)', rowSpan: 2, styles: {halign: 'center'}},
                                                {content: 'VAT Amount', rowSpan: 2, styles: {halign: 'center'}},
                                                {content: 'VAT Exempt\nSales', rowSpan: 2, styles: {halign: 'center'}},
                                                {content: 'Discount', colSpan: 2, styles: {halign: 'center'}},
                                                {content: 'Net Sales', rowSpan: 2, styles: {halign: 'center'}}
                                            ],
                                            [
                                                { content: "5%", styles: { halign: "center" } },
                                                { content: "20%", styles: { halign: "center" } }
                                            ]
                                        ]

                                      
                                        doc.autoTable({
                                            startY: design_y,
                                            head: headers,
                                            theme: 'plain',
                                            tableWidth: 'wrap',
                                            headStyles: {
                                                lineWidth: 0.15
                                            },
                                            styles: {
                                                cellPadding: 1.0, fontSize: 9,
                                                halign: 'right'
                                            },
                                            columnStyles: headerColStyles
                                        });
                                    } else {
                                        if(i != this.birSalesReports.length-1){
                                            let current_grouper = ""
                                            let next_grouper = ""

                                            if(this.inputGroupBy == 'user_id'){
                                                current_grouper = reportLine.user_id
                                                next_grouper = this.birSalesReports[i+1].user_id
                                            } else if(this.inputGroupBy == 'customer_id'){
                                                if(reportLine.customer_id == 0){
                                                    current_grouper = reportLine.customer_name
                                                    next_grouper = this.birSalesReports[i+1].customer_name
                                                } else {
                                                    current_grouper = reportLine.customer_id
                                                    next_grouper = this.birSalesReports[i+1].customer_id
                                                }
                                            }

                                            if(current_grouper != next_grouper){
                                                if(this.inputGroupBy != ''){
                                                    let total = [
                                                        '',
                                                        '',
                                                        '',
                                                        '', '', '',
                                                        'Total :',
                                                        this.convertToCurrency(total_amount_wvat),
                                                        this.convertToCurrency(total_vat_amount),
                                                        this.convertToCurrency(total_vat_exempt),
                                                        this.convertToCurrency(total_sp5_discount_amount),
                                                        this.convertToCurrency(total_sp20_discount_amount),
                                                        this.convertToCurrency(total_net_sales)
                                                    ]
                                                    reportData.push(Object.assign({}, ["rowLine"]))
                                                    reportData.push(Object.assign({}, total))

                                                    total_amount_wvat = 0
                                                    total_vat_amount = 0
                                                    total_vat_exempt = 0
                                                    total_sp5_discount_amount = 0
                                                    total_sp20_discount_amount = 0
                                                    total_net_sales = 0
                                                }
                                            }
                                        }
                                    }
                                }
                                main_grouper = reportLine.terminal_id

                                if(i == this.birSalesReports.length-1){
                                    //last record display terminal details
                                    design_y = design_y + 15

                                    if(this.inputGroupBy != ''){
                                        let total = [
                                            '',
                                            '',
                                            '',
                                            '', '', '',
                                            'Total :',
                                            this.convertToCurrency(total_amount_wvat),
                                            this.convertToCurrency(total_vat_amount),
                                            this.convertToCurrency(total_vat_exempt),
                                            this.convertToCurrency(total_sp5_discount_amount),
                                            this.convertToCurrency(total_sp20_discount_amount),
                                            this.convertToCurrency(total_net_sales)
                                        ]
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, total))
                                    }

                                    let grand = [
                                        '',
                                        '',
                                        '',
                                        '', '', '',
                                        'Grand Total :',
                                        this.convertToCurrency(g_amount_wvat),
                                        this.convertToCurrency(g_vat_amount),
                                        this.convertToCurrency(g_vat_exempt),
                                        this.convertToCurrency(g_sp5_discount_amount),
                                        this.convertToCurrency(g_sp20_discount_amount),
                                        this.convertToCurrency(g_net_sales)
                                    ]
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, grand))
                                      design_y = design_y + 5
                                    doc.autoTable({
                                        startY: design_y,
                                        body: reportData,
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0, 0, 0]
                                                data.cell.styles.fontSize = 1
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && (data.row.raw[3] == 'Grand Total :' || data.row.raw[3] == 'Total :') ){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        }
                                    });
                                } else {

                                }
                            }
                        }
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    for(i = 0; i < pageCount; i++) {
                        doc.setPage(i);
                        doc.text(340,210,"Page " + doc.internal.getCurrentPageInfo().pageNumber  + " of " + pageCount, "right")
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('warning', 'No data found, try increasing the scope by adjusting the filters.');
                }
                this.spinning= false;
            }
        }
    };
</script>

<style></style>
